import { BUTTON_SKELETON } from 'Component/Button/Button.config';

export const PRODUCT_DETAILS_SKELETON = [
    {
        type: 'group',
        className: 'border-t border-b border-bmBorder-primary border-solid',
        height: 70,
        flexDirection: 'row',
        alignItems: 'center',
        items: [
            {
                type: 'group',
                alignItems: 'left',
                gap: 0,
                items: [
                    { height: 22, maxWidth: 200 }
                ]
            },
            {
                type: 'group',
                alignItems: 'right',
                gap: 0,
                items: [
                    { height: 24, maxWidth: 24 }
                ]
            }

        ]
    }
];

export const SKELETON_MATERIAL = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        items: [
            {
                type: 'rect',
                width: '80px',
                height: '19px',
                marginBottom: '24px'
            }
        ]
    }
];

export const SKELETON_PRICE = [
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'items-start',
        items: [
           { width: '120px', height: '28px', marginBottom: '24px' }
        ]
    }
];

export const TOP_DETILS_SKELETON = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        className: 'pb-4 pl-4 lg:pl-0 lg:px-0 pt-4 lg:pt-0 ',
        items: [
            { marginBottom: '2px', width: '100px', height: '16px' },
            {
                maxWidth: '300px', width: '100%', marginBottom: '4px', height: '24px'
            }
        ]
    }
];

export const PRODUCT_OPTIONS_SKELETON = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'items-start',
        items: [

            { marginBottom: '8px', width: '100px', height: '16px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'items-start',
        gap: 8,
        columns: 3,
        className: 'pb-6',
        items: [
            { width: '36px', height: '36px', className: 'rounded-full' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'items-start',
        items: [
            { marginBottom: '8px', width: '140px', height: '16px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'items-start',
        gap: 8,
        columns: 3,
        className: 'pb-6',
        items: [
            { width: '80px', height: '44px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'items-start',
        items: [
            { marginBottom: '8px', width: '140px', height: '16px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'items-start',
        gap: 8,
        columns: 4,
        className: 'pb-6',
        items: [
            { width: '80px', height: '44px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'items-start',
        items: [
            { marginBottom: '8px', width: '140px', height: '16px' }
        ]
    },
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'items-start',
        gap: 8,
        columns: 3,
        className: 'pb-6',
        items: [
            { width: '80px', height: '44px' }
        ]
    }
];

export const DESKTOP_GALLERY_SKELETON = [
    {
        type: 'group',
        flexDirection: 'row',
        alignItems: 'flex-start',
        className: 'pb-16 flex',
        width: '100%',
        items: [
            {
                type: 'group',
                flexDirection: 'column',
                gap: '16px',
                width: 'auto',
                className: 'flex items-start mr-4',
                columns: 4,
                items: [
                    { type: 'rect', height: '120px', width: '96px' }
                ]
            },
            {
                height: '760px',
                maxWidth: '607px',
                width: '100%'
            }
        ]
    }
];

export const MOBILE_GALLERY_SKELETON = [
    {
        type: 'group',
        gap: '16px',
        flexDirection: 'column',
        alignItems: 'items-start',
        className: 'pb-6',
        items: [
            {
                type: 'rect',
                width: '100%',
                height: '100%',
                className: 'aspect-square w-full'
            }
        ]
    }
];

export const QUANTITY_SKELETON = [
    {
        height: 56,
        className: 'max-w-[140px]! w-full mr-3'
    }
];

export const ADDTOCART_SKELETON = [
  {
    type: 'group',
    flexDirection: 'row',
    alignItems: 'center',
    className: 'mb-6!',
    gap: 12,
    items: [
      ...QUANTITY_SKELETON,
      ...BUTTON_SKELETON
    ]
  }
];

export const PRODUCT_PAGE_GENERAL_DESKTOP_SKELETON = [
   {
        type: 'group',
        flexDirection: 'row',
        gap: 64,
        alignItems: 'flex-start',
        className: 'max-w-1400! mx-auto lg:px-11',
        items: [
            {
                type: 'group',
                maxWidth: '719px',
                width: '100%',
                items: [
                    ...DESKTOP_GALLERY_SKELETON
                ]
            },
            {
                type: 'group',
                flexDirection: 'column',
                maxWidth: '528px',
                width: '100%',
                items: [
                    ...TOP_DETILS_SKELETON,
                    ...SKELETON_PRICE,
                    ...SKELETON_MATERIAL,
                    ...PRODUCT_OPTIONS_SKELETON,
                    ...ADDTOCART_SKELETON
                ]
            }
        ]
   }
]

export const PRODUCT_PAGE_GENERAL_MOBILE_SKELETON = [
    {
        type: 'group',
        flexDirection: 'column',
        alignItems: 'flex-start',
        className: 'pl-4 pb-2 pt-4',
        items: [
             {
                height: '16px',
                width: '200px',
                className: 'mb-1'
            },
            {
                height: '24px',
                width: '300px'
            }
        ]
    },
   {
        type: 'group',
        flexDirection: 'column',
        items: [
            {
                type: 'group',
                width: '100%',
                items: [
                    ...MOBILE_GALLERY_SKELETON
                ]
            },
            {
                type: 'group',
                flexDirection: 'column',
                width: '100%',
                className: 'px-4',
                items: [
                    ...SKELETON_PRICE,
                    ...SKELETON_MATERIAL,
                    ...PRODUCT_OPTIONS_SKELETON,
                    ...ADDTOCART_SKELETON
                ]
            }
        ]
   }
]

export const PRODUCT_DETAIL_SKELETON = [
     {
        type: 'group',
        flexDirection: 'row',
        width: '100%',
        gap: 12,
        className: 'pb-3',
        items: [
            {
                height: '19px', width: '40px' 
            },
            {
                height: '19px', width: '250px'
            }
        ]

    }
]